import React, {useContext} from 'react'
import classnames from 'classnames'

import {SlotCard} from '../../../ui/cards/SlotCard'
import {AppButton, Text} from '../../../ui/components'
import {ImageComponent} from '../../../ui/components'
import {platformToInvertedIconMap} from '../../../ui/components/AppButton/constants'
import {Context} from '../../Context'
import {TAppBlock} from '../../types'

import styles from './styles.module.css'

type TAppBlockProps = TAppBlock & {className?: string}

export function AppBlock({title, caption, qrCode, appLinks, className, appGoal, googleGoal}: TAppBlockProps) {
  const {reachGoal} = useContext(Context)

  return (
    <SlotCard className={classnames(styles.appBlock, className)}>
      <Text tag="p" kind="body" color="controlBlack">
        {title}
      </Text>
      <Text tag="p" kind="caption" color="textGrey">
        {caption}
      </Text>
      <div className={styles.downloadApp}>
        <div className={styles.appButtons}>
          {appLinks.map(({platform, link}) => (
            <AppButton
              key={platform}
              icons={[platformToInvertedIconMap.get(platform)]}
              href={link}
              variant="hollow"
              onClick={() =>
                platform === 'apple' ? appGoal && reachGoal?.(appGoal) : googleGoal && reachGoal?.(googleGoal)
              }
              invertColors
              className={styles.downloadAppButton}
            />
          ))}
        </div>
        {qrCode && (
          <div className={styles.downloadAppImageContainer}>
            <ImageComponent alt={qrCode.alt} src={qrCode.src.toString()} className={styles.downloadAppImage} />
          </div>
        )}
      </div>
    </SlotCard>
  )
}
